<script setup lang="ts">
defineOptions({
	name: "admin.temp",
});
definePage({
	name: "admin.temp",
	redirect: "/admin/temp",
	meta: {
		hasKeepAlive: ["admin.schools"],
		permissions: "view-teacher-management",
	},
});
</script>

<template>
	<div class="sup-page">
		<router-view />
	</div>
</template>

<style scoped lang="scss"></style>
